module.exports = __webpack_public_path__ + "img/skrill.ec1a287f.svg";